let ua = {}
const n = navigator
const a = n.appVersion
const u = n.userAgent
const T = true
const F = false
const w = window
let b
let bw
let v
const l = n.language || n.systemLanguage
let web = T
let webkit = F

ua = {}
if (w.ActiveXObject || w.msIndexedDB) {
  b = 'ie'
  bw = 'IE'
  v = a.match(/MSIE (\d+)\./) || a.match(/rv:(\d+)\./) || a.match(/Edge\/(\d+)\./)
} else if (w.mozIndexedDB || w.mozRequestAnimationFrame) {
  b = 'ff'
  bw = 'Firefox'
  v = u.match(/Firefox\/(\d+)\./)
} else if (w.chrome || a.match(/Chrome/)) {
  b = 'ch'
  bw = 'Chrome'
  v = a.match(/Chrome\/(\d+)\./)
  webkit = T
} else if (w.opera || /Opera/.test(a)) {
  b = 'op'
  bw = 'Opera'
  v = u.match(/Version\/(\d+)\./)
} else if (/Safari/.test(a)) {
  if (/iPad/.test(a)) {
    b = 'ipad'
    bw = 'Safari'
    web = F
    webkit = T
  } else if (/iPhone/.test(a)) {
    b = 'iphone'
    bw = 'iPhone'
    web = F
    webkit = T
  } else if (/Android/.test(a)) {
    b = 'android'
    bw = 'Android'
    web = F
  } else {
    b = 'sa'
    bw = 'sa'
    webkit = T
  }
  v = a.match(/Version\/(\d+)\./)
} else if (/mobile/i.test(a)) {
  web = F
  webkit = /webkit/i.test(a)
  v = a.match(/(\d+)/) // unknown

  if (/IEMobile|Windows Phone/.test(u)) {
    b = 'wp'
    bw = 'Windows Phone'
  } else if (/iPad/i.test(a)) {
    b = 'ipad'
    bw = 'ipad'
  } else if (/iPhone/.test(a)) {
    b = 'iphone'
    bw = 'iPhone'
  } else if (/Android/.test(a)) {
    b = 'android'
    bw = 'android'
  }
} else {
  b = 'unknow'
  bw = 'unknow'
}

ua.name = b
ua.version = v && v[1] ? parseInt(v[1], 10) : 0
ua.web = web
ua.webkit = webkit
ua.lang = l.toLowerCase()
ua.client = `web_(${bw}+${ua.version})`
ua[b] = ua[b + ua.version] = T
// ua.wap = ua.ipad ? F : /android|iphone|blackberry|mobile/i.test(u);
ua.wap = !/ipad/i.test(u) && /android|iphone|blackberry|mobile/i.test(u)

ua.os = (function () {
  const na = navigator
  const ua = na.userAgent
  const pf = na.platform

  const win = pf.startsWith('Win') // == 'Win32' || pf == 'Windows';
  const mac = pf.startsWith('Mac') // == 'Mac68K' || pf == 'MacPPC' || pf == 'Macintosh' || pf == 'MacIntel';

  if (mac) return 'Mac'
  if (pf == 'X11' && !win && !mac) return 'Unix'
  if (pf.includes('Linux')) return 'Linux'

  if (win) {
    // 如果修改了 ua, 目前无法检测
    if (ua.includes('Windows NT 5.0') || ua.includes('Windows 2000')) return 'Win2000'
    if (ua.includes('Windows NT 5.1') || ua.includes('Windows XP')) return 'WinXP'
    if (ua.includes('Windows NT 5.2') || ua.includes('Windows 2003')) return 'Win2003'
    if (ua.includes('Windows NT 6.0') || ua.includes('Windows Vista')) return 'WinVista'
    if (ua.includes('Windows NT 6.1') || ua.includes('Windows 7')) return 'Win7'
  }

  return pf
})()

export default ua
